import React, { useRef, useEffect } from "react";
import { IconSparkles } from "@tabler/icons-react";
import Message, { MessageProps } from "./Message";

interface MessageListProps {
  messages: MessageProps[];
  isLoading: boolean;
}

const MessageList: React.FC<MessageListProps> = ({ messages, isLoading }) => {
  const chatEndRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  if (messages.length === 0) {
    return (
      <div className="text-center py-16 flex flex-col items-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-brand-primary/10 rounded-full mb-6">
          <IconSparkles className="h-10 w-10 text-brand-primary" />
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          How can I assist you today?
        </h2>
        <p className="text-gray-500 max-w-lg mx-auto">
          Ask me anything about devx. I'll search through the knowledge
          base to provide accurate answers.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      {messages.map((message) => (
        <Message key={message.id} {...message} />
      ))}

      {isLoading && (
        <div className="flex justify-start">
          <div className="max-w-[85%] p-4 rounded-2xl bg-white border border-gray-200 shadow-sm">
            <div className="flex space-x-2">
              <div
                className="h-2 w-2 bg-gray-300 rounded-full animate-bounce"
                style={{ animationDelay: "0ms" }}
              ></div>
              <div
                className="h-2 w-2 bg-gray-300 rounded-full animate-bounce"
                style={{ animationDelay: "150ms" }}
              ></div>
              <div
                className="h-2 w-2 bg-gray-300 rounded-full animate-bounce"
                style={{ animationDelay: "300ms" }}
              ></div>
            </div>
          </div>
        </div>
      )}

      <div ref={chatEndRef} />
    </div>
  );
};

export default MessageList;
